import { createEnum } from '../helpers'

export const CURRENCY_RATES_CREATE_ERRORS = ['currencyRateNameConflict'] as const

export const CURRENCY_RATES_CREATE_ERROR_TYPES = createEnum(CURRENCY_RATES_CREATE_ERRORS)
export type CurrencyRatesCreateErrorType = (typeof CURRENCY_RATES_CREATE_ERRORS)[number]

export const CURRENCY_RATES_CREATE_CONSTRAINT_TO_ERROR: Record<
  string,
  CurrencyRatesCreateErrorType
> = {
  currency_rates_name_unique: CURRENCY_RATES_CREATE_ERROR_TYPES.currencyRateNameConflict,
}
